export default __webpack_public_path__ + "static/media/yourturn-landing(mobile).955f9680.png";